import { Controller } from 'stimulus';
import Swiper, { Pagination, EffectFade, Navigation, Controller as SwiperController } from 'swiper';

class QuotesCarousel extends Controller {

  connect() {
    // Quotes carousel
    Swiper.use([Pagination, EffectFade, Navigation, SwiperController]);
    
    const carousels = document.querySelectorAll('.swiper-quotes-carousel');

    /**
     * Adds a unique class to the element and returns the new class name 
     * 
     * @param {String} className 
     * @param {Int} uniqueId 
     * @returns String unique classname
     */
    const uniqueEls = (className, containerEl, uniqueId) => {
      if (containerEl.querySelector(`.${className}`)) containerEl.querySelector(`.${className}`).classList.add(`${className}__${uniqueId}`);
      return `.${className}__${uniqueId}`;
    }

    carousels.forEach((carousel, i) => {
      const quotes = carousel;
      if (quotes.dataset.initialized) return;
      else quotes.dataset.initialized = true;

      quotes.classList.add(`swiper-quotes-carousel__${i}`);
      const quotesContainer = quotes.parentNode.parentNode;
      const sliderFunction = (settings = {}) => {
        const genSettings = {
          autoHeight: true,
          grabCursor: true,
          loop: false,
          loopFillGroupWithBlank: true,
          watchOverflow: true,
          navigation: {
            nextEl: uniqueEls('swiper-quotes-carousel-button--next', quotesContainer, i),
            prevEl: uniqueEls('swiper-quotes-carousel-button--prev', quotesContainer, i),
          },
          slideVisibleClass: 'quotes-carousel-visible',
          slidePrevClass: 'quotes-carousel-prev',
          slideNextClass: 'quotes-carousel-next',
        };
        settings = {
          autoplay: {
            delay: 5000,
          },
          breakpoints: {
            1280: {
              autoHeight: false,
            },
          },
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          pagination: {
            el: uniqueEls('swiper-quotes-carousel-pagination', quotesContainer, i),
            bulletClass: 'swiper-pagination-bullet swiper-pagination-bullet-secondary',
            bulletActiveClass: 'swiper-pagination-bullet-active swiper-pagination-bullet-active-secondary',
            clickable: true,
          },
          on: {
            init: function(swiper) {
              if(swiper.slides.length <= 1) {
                $(`.swiper-quotes-carousel-button--next__${i}`).hide();
                $(`.swiper-quotes-carousel-button--prev__${i}`).hide();
              }
            },
          },
          ...genSettings
        };
        return settings;
      }
      const quotes_slider = new Swiper(`.swiper-quotes-carousel__${i}`, sliderFunction()); 
      quotes_slider.controller.control = quotes_slider;
    });
  }
}

QuotesCarousel.targets = ['slider'];

export default QuotesCarousel;